require('./overrides.scss')

const preset = {
  theme: {
    themes: {
      light: {
        primary: '#056ab2',
        secondary: '#FFCE2E',
        accent: '#71B846',
        error: '#CF3435',
        info: '#2196F3',
        success: '#5B9F31',
        warning: '#FFC107',
      },
    },
    options: {
      customProperties: true
    },
  },
}

module.exports = { preset }
